export default "__VITE_ASSET__b0c321d9__"